export const contentGutterClass = 'px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 min-[1440px]:px-[100px]';

export const contentTopPadClass = 'pt-8 md:pt-12';

export const heroMinHeightClass = 'min-h-[698px] md:min-h-[758px]';

/** Отступ якоря при прокрутке (хедер + запас). */
export const sectionScrollMarginClass = 'scroll-mt-[calc(var(--header-height)+16px)]';

export const navPillClassName =
  'inline-flex items-center justify-center align-middle rounded-[80px] border border-solid border-[#FFFFFF24] bg-[rgba(255,255,255,0.06)] px-[12px] py-[6px] text-center font-sans font-semibold text-[12px] leading-[100%] tracking-normal text-[#F4F4F4] backdrop-blur-[84px] transition-[color,border-color] duration-200 hover:border-[#A9F84A] hover:text-[#A9F84A] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#A9F84A]/40 md:px-[14px] md:py-[8px] md:text-[13px] md:leading-[20px]';

export const sectionTextureStyle = {
  backgroundImage: "url('/images/original-plus/section-texture.png')",
} as const;

export const sectionPaperTextureStyle = {
  backgroundImage: "url('/images/original-plus/page-paper-texture.png')",
} as const;

export const pageRepeatingTextureLayerClassName =
  'pointer-events-none absolute inset-0 z-0 bg-[length:100%_auto] bg-repeat-y bg-top';

export const pagePaperTextureLayerClassName =
  'pointer-events-none absolute inset-0 z-0 bg-[length:100%_auto] bg-repeat-y bg-top opacity-60 mix-blend-luminosity';

export const sectionEyebrowClassName =
  'font-sans text-[12px] font-semibold uppercase leading-[18px] tracking-[1px] text-[#A9F84A]';

export const sectionDisplayTitleClassName =
  'roboto-flex-compressed font-extra-black text-[50px] uppercase leading-[90%] tracking-normal text-white md:text-[70px]';
